import React, { useContext, useEffect, useMemo, useState } from 'react';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';

import { AuthContext } from 'context/authContext';
import { setTokenAndBootstrapSession } from 'services/ssoAuth';

function normalizeToken(tokenParam) {
  if (!tokenParam || typeof tokenParam !== 'string') return '';

  let decoded = '';
  try {
    decoded = decodeURIComponent(tokenParam);
  } catch (e) {
    // If token isn't URI encoded, fall back to raw value
    decoded = tokenParam;
  }

  return decoded.replace(/\s+/g, '').trim();
}

export default function PingSSOLogin() {
  const { token: tokenParam } = useParams();
  const token = useMemo(() => normalizeToken(tokenParam), [tokenParam]);

  const [searchParams] = useSearchParams();
  const encodedSession = searchParams.get('p') || null;

  const navigate = useNavigate();
  const { authDispatch } = useContext(AuthContext);

  const [status, setStatus] = useState(
    token ? 'processing' : 'missing_token'
  );
  const [errorText, setErrorText] = useState('');

  useEffect(() => {
    let cancelled = false;

    async function run() {
      if (!token) return;
      setStatus('processing');

      try {
        await setTokenAndBootstrapSession(token, authDispatch, encodedSession);
        if (cancelled) return;
        navigate('/', { replace: true });
      } catch (err) {
        if (cancelled) return;
        setErrorText('SSO link expired/invalid');
        setStatus('failed');

        // Ensure token is cleared, then bounce to normal login with message
        setTimeout(() => {
          navigate('/auth/login?error=sso_invalid', { replace: true });
        }, 500);
      }
    }

    run();
    return () => {
      cancelled = true;
    };
  }, [token, encodedSession, authDispatch, navigate]);

  if (status === 'missing_token') {
    return (
      <div className="flex justify-center items-center relative h-screen w-screen">
        <div className="max-w-md w-full px-6">
          <p className="text-lg font-semibold text-center">Token missing</p>
          <button
            className="mt-6 w-full bg-[#FB7C51] text-white rounded h-10"
            onClick={() => navigate('/auth/login', { replace: true })}
          >
            Go to Login
          </button>
        </div>
      </div>
    );
  }

  if (status === 'failed') {
    return (
      <div className="flex justify-center items-center relative h-screen w-screen">
        <div className="max-w-md w-full px-6">
          <p className="text-lg font-semibold text-center">{errorText}</p>
          <button
            className="mt-6 w-full bg-[#FB7C51] text-white rounded h-10"
            onClick={() => navigate('/auth/login', { replace: true })}
          >
            Go to Login
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="flex justify-center items-center relative h-screen w-screen">
      <p>Signing you in…</p>
    </div>
  );
}

